import { type FilterValues } from "components/filters/FilterContext";
import { mapKeywordFilterToInstruction, mapResponseToKeywordFilter } from "components/filters/mappingUtils";

export const mapFilterValuesToInstruction = (
  mainArea: server.dto.MainAreas,
  filterSet: server.dto.FilterSets,
  filter: FilterValues,
  page: number,
  perPage: number
): server.dto.PaginatedExcelTemplateInstruction => {
  return {
    keyword: mapKeywordFilterToInstruction(filter.keyword),
    page,
    perPage,
    cache: filterSet,
    mainArea
  };
};

export const mapResponseToFilterValues = (
  response: server.dto.ListExcelTemplateFilters,
  _: FilterValues
): Partial<FilterValues> => ({
  keyword: mapResponseToKeywordFilter(response.keyword),
});

export const getFilterSet = (mainArea: server.dto.MainAreas): server.dto.FilterSets => {
  switch (mainArea) {
    case "show": return "excelTemplate_Show_List";
    case "company": return "excelTemplate_Company_List";
    case "contact": return "excelTemplate_Contact_List";
    case "invoice": return "excelTemplate_Invoice_List";
    case "contract": return "excelTemplate_Contract_List";
    case "purchaseAgreement": return "excelTemplate_PurchaseAgreement_List";
    case "quote": return "excelTemplate_Quote_List";
    case "production": return "excelTemplate_Production_List";
  }
}